// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalSuccess_wrapper__LKg2L","modal":"ModalSuccess_modal__pi+Ax","title":"ModalSuccess_title__X302Y","description":"ModalSuccess_description__ixX9-"};